import { completeRenewToken } from "src/app/services/authService";
function TokenRenewSuccessPage() {
    completeRenewToken();
    return null;
}
export default TokenRenewSuccessPage;
